import React, { useState } from "react";
import "./Events.css";
import "../../../../../App.css";
import "../../../../_Shared/utility.css";
import EventsTile from "../../../../EventsTiles/EventTiles";
import { FRBanner } from "../../../../Banner/Banner";
import { Helmet } from "react-helmet-async";
import { cdn } from "../../../../../consts/cdn";
import ExternalLinkModal from "../../../../Modals/ExternalLink/ExternalLinkModal";
import { sendWatchEventLinkClick } from "../../../../../utilities/GoogleAnalyticsEvents";

//Images
const BannerDesktop = cdn.images + "Events/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "Events/Banner-Mobile.jpg";

function Events() {
  const [showModal, setShowModal] = useState(false);
  const [externalUrl, setExternalUrl] = useState("");
  const [currentEvent, setCurrentEvent] = useState(null);

  const handleStudyClick = (title, url) => {
    try {
      const currentDomain = window.location.hostname;
      const linkDomain = new URL(url).hostname;

      if (linkDomain !== currentDomain) {
        setExternalUrl(url);
        setCurrentEvent({ title, url });
        setShowModal(true);
      } else {
        // Navigate to internal link directly
        window.location.href = url;
      }
    } catch (error) {
      console.error("Invalid URL:", url);
    }
  };

  const proceedToExternalLink = () => {
    if (currentEvent) {
      sendWatchEventLinkClick(currentEvent.title, currentEvent.url);
    }

    setShowModal(false);
    window.open(externalUrl, "_blank");
  };

  return (
    <div className="events">
      <Helmet>
        <title>
          vNOTES – Advanced Minimally Invasive Gynecologic Procedures
        </title>
        <meta
          name="description"
          content="vNOTES (vaginal natural orifice transluminal endoscopic surgery) workshops provide a comprehensive understanding of procedural steps and instrumentation used…"
        />
      </Helmet>
      <div className={`FRBanner ${showModal ? "blur" : ""}`}>
        <FRBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="ÉVÈNEMENTS"
          color="#365B7E"
        />
      </div>

      <div className={`content ${showModal ? "blur" : ""}`}>
        <EventsTile
          date="septembre 2026"
          title="Passez à la prochaine étape avec le vNOTES : les cas complexes d'hystérectomie"
          content="Regardez une présentation dynamique animée par des experts de la chirurgie vNOTES, qui partagent leurs retours d'expérience et les points clés à considérer dans la prise en charge des hystérectomies complexes. Les intervenants partagent des vidéos de cas et des conseils pratiques sur les approches preopératoires et la sélection des patientes. Développez votre expertise technique pour relever les défis des cas d'hystérectomie complexes grâce au vNOTES." 
          doctors="Dr. Beatriz Bueno Olalla, Dr. Grover May, Dr. Martine Wassen"
          banner
          webinar
          pastevent
          comingsoonurl="https://appliedmedical.zoom.us/webinar/register/WN_GL3aZVjHTA2tgXLpGwdCZg#/registration"
          onExternalLinkClick={handleStudyClick}
        />
        <EventsTile
          date="mai 2026"
          title="Applications du vNOTES en uro-gynécologie"
          content="Regardez une discussion animée par des experts sur les avantages de la technique vNOTES en chirurgie uro-gynécologique. Des chirurgiens spécialisés présenteront des techniques de prise en charge du prolapsus des organes pelviens avec le vNOTES, ainsi que des données cliniques et leurs retours d’expérience." 
          webinar
          eventurl="https://web.vablet.com/AakViewer?aak=3b346dd3-24cb-4cf5-9491-9d71ec89efb3&om=1236678&autoOpen=true#msdynmkt_trackingcontext=b591ac84-e303-46cb-b5c1-9e8498630100"
          onExternalLinkClick={handleStudyClick}
        />
        <EventsTile
          date="novembre 2025"
          title="vNOTES pour la pathologie annexielle"
          content="Regardez les Docteurs Baekelandt et May pour découvrir comment l’approche vNOTES peut permettre une approche chirurgicale moins invasive pour les procédures annexielles. Au cours de ce webinaire, les experts analysent la vidéo complète d’une procédure annexielle complexe par vNOTES, réalisée par le Dr. Baekelandt. Ils partagent leur expertise ainsi que leurs principaux enseignements sur la technique vNOTES durant la présentation."
          doctors="Dr. Jan Baekelandt et Dr. Grover May"
          webinar
          eventurl="https://vablet.com/s/bZHIOnT"
          onExternalLinkClick={handleStudyClick}
        />
        <EventsTile
          date="novembre 2025"
          title="vNOTES pour la pathologie annexielle"
          content="Regardez les Docteurs Baekelandt et May pour découvrir comment l’approche vNOTES peut permettre une approche chirurgicale moins invasive pour les procédures annexielles. Au cours de ce webinaire, les experts analysent la vidéo complète d’une procédure annexielle complexe par vNOTES, réalisée par le Dr. Baekelandt. Ils partagent leur expertise ainsi que leurs principaux enseignements sur la technique vNOTES durant la présentation."
          doctors="Dr. Jan Baekelandt et Dr. Grover May"
          webinar
          eventurl="https://vablet.com/s/bZHIOnT"
          onExternalLinkClick={handleStudyClick}
        />
        <EventsTile
          date="septembre 2025"
          title="Pourquoi le vNOTES comme 1ère voie d'abord ?"
          content="Revivez un webinaire passionnant avec des experts internationaux, qui partagent l’évolution de leurs pratiques depuis l’adoption de la technique vNOTES. Le panel apporte ses perspectives uniques sur cette approche innovante, met en lumière l’élargissement des indications patientes et illustre ses propos avec des vidéos de cas complexes. Les intervenants reviennent également sur les avantages du vNOTES et expliquent pourquoi ils choisissent de le proposer en première intention à leurs patients."
          doctors="Dr. Géraldine Giraudet, Dr. Andrea Stuart et Dr. Jona Vercammen"
          webinar
          eventurl="https://vablet.com/s/ce2Ajfd"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="mai 2024"
          title="Cycle complet de la chirurgie vNOTES : du médecin au patient"
          content="Regardez les docteurs Baker, Boggs et Hardin présenter des vidéos d’interventions et expliquer pourquoi la technique vNOTES est leur méthode de prédilection. Forts d'expériences variées, allant de la chirurgie vaginale traditionnelle à la robotique, chaque chirurgien partagera son expérience sur la manière dont le vNOTES améliore l'accès et la visibilité lors d'interventions complexes, tout en optimisant les résultats pour les patientes. Le Dr. Boggs évoquera également son expérience en tant que patiente vNOTES et comment sa récupération rapide lui a permis de retourner au bloc opératoire en moins de deux semaines."
          doctors="Dr. Elizabeth Baker, Dr. Elizabeth Boggs et Dr. Brandi Hardin"
          webinar
          eventurl="https://vablet.com/s/uIsBQYw"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="octobre 2023"
          title="Série de webinaires vNOTES : progresser dans sa pratique"
          content="Écoutez des chirurgiens experts expliquer comment ils ont fait évoluer leur pratique grâce au vNOTES. Observez les présentations de situations sur la façon d'aborder les cas complexes en vNOTES, tels que les procédures annexielles et l'ablation de gros utérus."
          doctors="Dr. Jean Dubuisson, Dr. Géraldine Giraudet et Dr. Grover May"
          webinar
          eventurl="https://vablet.com/s/e3Uz8b7"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="septembre 2023"
          title="Visibilité et accessibilité : pourquoi le vNOTES prend tout son sens dans ma pratique"
          content="Dans ce webinaire parrainé par l'AUGS, les docteurs Iglesia, Lindo, Pitman et Zoorob expliquent pourquoi ils choisissent l'approche vNOTES pour leurs interventions uro-gynécologiques. Observez les présentations de cas vidéo pour voir comment le vNOTES améliore l'accès vaginal et la visualisation. En outre, le groupe d'experts vous fera part de ses expériences concrètes et des résultats obtenus par les patientes lors de l'utilisation de cette approche innovante."
          doctors="Dr. Cheryl Iglesia, Dr. Fiona Lindo, Dr. Thomas Pitman et Dr. Dani Zoorob"
          webinar
          eventurl="https://www.youtube.com/watch?v=RfV-H-bgGIE"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="mai 2023"
          title="Série de webinaires vNOTES : fondements de l’hystérectomie vNOTES"
          content="Découvrez les principes fondamentaux du vNOTES grâce à un groupe d'experts qui passent en revue une hystérectomie vNOTES complète, notamment la sélection des patientes, l'installation de la salle d'opération et de la plateforme GelPOINT™ V-Path, la création d'une colpotomie, les soins post-opératoires et les résultats pour les patientes."
          extra="Que vous soyez novice en matière de vNOTES ou curieux d'en savoir plus, regardez ce webinaire pour comprendre ce qu'implique une hystérectomie vNOTES et comment cette procédure peut être bénéfique pour vous et vos patientes."
          doctors="Dr. Asha Bhalwal, Dr. Brandi Hardin et Dr. Jay Matkins"
          webinar
          eventurl="https://vablet.com/s/tcdk8y5"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="octobre 2022"
          title="Pratiquer l'annexectomie avec vNOTES"
          content="Découvrez pourquoi le Dr. Giraudet a adopté la technique vNOTES et regardez ses vidéos de cas d'annexectomie, où elle explique les avantages de cette approche pour cette intervention."
          doctor=" Dr. Géraldine Giraudet"
          symposium
          eventurl="https://vablet.com/s/uPegYP7"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="octobre 2022"
          title="Réparation du prolapsus avec vNOTES"
          content="Le Dr. Dubuisson présente des vidéos de cures de prolapsus vNOTES, partage les dernières données cliniques et décrit les avantages de l'adoption de cette approche innovante."
          doctor=" Dr. Jean Dubuisson"
          symposium
          eventurl="https://vablet.com/s/tXJjPvH"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="octobre 2021"
          title="vNOTES : élargissez vos horizons en matière de chirurgie vaginale"
          content="Écoutez un panel d'experts chirurgiens de toute l'Europe partager leurs expériences avec la technique vNOTES. Ces experts présentent des vidéos d'annexectomie et d'hystérectomie vNOTES, suivies d'une discussion sur les avantages, les indications et les preuves cliniques."
          doctors="M. Oudai Ali et Dr. Jan Baekelandt, Dr. Martine Wassen, Dr. Géraldine Giraudet et Dr. Jean Dubuisson"
          symposium
          eventurl="https://vablet.com/s/sTCRv1k"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="février 2021"
          title="vNOTES : moderniser la chirurgie vaginale"
          content="Des experts discutent de l'évolution du vNOTES et partagent des vidéos qui donnent un aperçu des avantages cliniques, des indications et du parcours de formation pour cette nouvelle approche."
          doctors="Dr. Jan Baekelandt, Dr. Jean Dubuisson, Dr. Susanne Housmans, Dr. Martine Wassen, Dr. Nicol Smeets et Dr. Aslam Mansoor"
          webinar
          eventurl="https://vablet.com/s/R3Yh9gU"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
        <EventsTile
          date="décembre 2020"
          title="Hystérectomie vNOTES d'un gros utérus"
          content="Regardez une démonstration étape par étape de la technique d'hystérectomie vNOTES pour une patiente ayant un gros utérus. Découvrez les indications vNOTES et les trucs et astuces pour augmenter le succès de la chirurgie."
          doctor=" Dr. Jan Baekelandt "
          symposium
          eventurl="https://vablet.com/s/Ohamyhw"
          onExternalLinkClick={handleStudyClick} // Pass the handler
        />
      </div>
      <ExternalLinkModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onProceed={proceedToExternalLink}
      />
    </div>
  );
}

export default Events;
